import {
  Companion_getInstance3lubwpz5lc00p as Companion_getInstance,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
} from './databaseModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { TimerAction2lzic48mzpw2s as TimerAction } from './supportModels.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import { Duration5ynfiptaqcrg as Duration } from '../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_incident(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectTimer_incident_getInstance());
}
function get_action(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectTimer_action_getInstance());
}
function get_lineItem(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectTimer_lineItem_getInstance());
}
function get_executed(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectTimer_executed_getInstance());
}
function get_project(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectTimer_project_getInstance());
}
function prepareProjectTimerFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [ProjectTimer__id_getInstance(), ProjectTimer_project_getInstance(), ProjectTimer_lineItem_getInstance(), ProjectTimer_incident_getInstance(), ProjectTimer_payApp_getInstance(), ProjectTimer_durationLeft_getInstance(), ProjectTimer_executesAt_getInstance(), ProjectTimer_pausedFromDispute_getInstance(), ProjectTimer_action_getInstance(), ProjectTimer_businessDaysOnly_getInstance(), ProjectTimer_minimumTimeWhenResumed_getInstance(), ProjectTimer_executed_getInstance()];
  var tmp = Companion_getInstance().k2a();
  properties(tmp, (it) => props);
}
function get_executesAt(_this__u8e3s4) {
  return _this__u8e3s4.prop(ProjectTimer_executesAt_getInstance());
}
function ProjectTimer_incident$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(3);
}
function ProjectTimer_incident$_get_name_$ref_bku6vm() {
  return (p0) => p0.i20();
}
function ProjectTimer_incident$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_incident$_get_serializer_$ref_r73rpj() {
  return (p0) => p0.h2j();
}
function ProjectTimer_incident$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(3);
}
function ProjectTimer_incident$_get_annotations_$ref_pcsv8j() {
  return (p0) => p0.bz();
}
var ProjectTimer_incidentClass;
function ProjectTimer_incident() {
  if (ProjectTimer_incidentClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_incident_instance = this;
        var tmp = this;
        tmp.j7t_1 = lazy(ProjectTimer_incident$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k7t_1 = lazy(ProjectTimer_incident$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l7t_1 = lazy(ProjectTimer_incident$annotations$delegate$lambda);
        this.m7t_1 = null;
        this.n7t_1 = 'null';
      }
      i20() {
        var tmp0 = this.j7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_incident$_get_name_$ref_bku6vm(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.s7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      b7u(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.b7u(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.k7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_incident$_get_serializer_$ref_r73rpj(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l7t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_incident$_get_annotations_$ref_pcsv8j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_incident', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_incidentClass = $;
  }
  return ProjectTimer_incidentClass;
}
var ProjectTimer_incident_instance;
function ProjectTimer_incident_getInstance() {
  if (ProjectTimer_incident_instance === VOID)
    new (ProjectTimer_incident())();
  return ProjectTimer_incident_instance;
}
function ProjectTimer_action$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(8);
}
function ProjectTimer_action$_get_name_$ref_g9v3li() {
  return (p0) => p0.i20();
}
function ProjectTimer_action$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[8];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_action$_get_serializer_$ref_c92n1() {
  return (p0) => p0.h2j();
}
function ProjectTimer_action$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(8);
}
function ProjectTimer_action$_get_annotations_$ref_qniccf() {
  return (p0) => p0.bz();
}
var ProjectTimer_actionClass;
function ProjectTimer_action() {
  if (ProjectTimer_actionClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_action_instance = this;
        var tmp = this;
        tmp.d7u_1 = lazy(ProjectTimer_action$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.e7u_1 = lazy(ProjectTimer_action$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.f7u_1 = lazy(ProjectTimer_action$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.d7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_action$_get_name_$ref_g9v3li(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.x7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      g7u(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.g7u(tmp, value instanceof TimerAction() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.e7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_action$_get_serializer_$ref_c92n1(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.f7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_action$_get_annotations_$ref_qniccf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_action', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_actionClass = $;
  }
  return ProjectTimer_actionClass;
}
var ProjectTimer_action_instance;
function ProjectTimer_action_getInstance() {
  if (ProjectTimer_action_instance === VOID)
    new (ProjectTimer_action())();
  return ProjectTimer_action_instance;
}
function ProjectTimer_lineItem$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(2);
}
function ProjectTimer_lineItem$_get_name_$ref_cihttz() {
  return (p0) => p0.i20();
}
function ProjectTimer_lineItem$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_lineItem$_get_serializer_$ref_9l774i() {
  return (p0) => p0.h2j();
}
function ProjectTimer_lineItem$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(2);
}
function ProjectTimer_lineItem$_get_annotations_$ref_2yy5ji() {
  return (p0) => p0.bz();
}
var ProjectTimer_lineItemClass;
function ProjectTimer_lineItem() {
  if (ProjectTimer_lineItemClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_lineItem_instance = this;
        var tmp = this;
        tmp.h7u_1 = lazy(ProjectTimer_lineItem$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i7u_1 = lazy(ProjectTimer_lineItem$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j7u_1 = lazy(ProjectTimer_lineItem$annotations$delegate$lambda);
        this.k7u_1 = null;
        this.l7u_1 = 'null';
      }
      i20() {
        var tmp0 = this.h7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_lineItem$_get_name_$ref_cihttz(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.r7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      b7u(receiver, value) {
        return receiver.c7u(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.b7u(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.i7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_lineItem$_get_serializer_$ref_9l774i(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_lineItem$_get_annotations_$ref_2yy5ji(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_lineItem', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_lineItemClass = $;
  }
  return ProjectTimer_lineItemClass;
}
var ProjectTimer_lineItem_instance;
function ProjectTimer_lineItem_getInstance() {
  if (ProjectTimer_lineItem_instance === VOID)
    new (ProjectTimer_lineItem())();
  return ProjectTimer_lineItem_instance;
}
function ProjectTimer_executed$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(11);
}
function ProjectTimer_executed$_get_name_$ref_b4m1tb() {
  return (p0) => p0.i20();
}
function ProjectTimer_executed$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[11];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_executed$_get_serializer_$ref_5giw6i() {
  return (p0) => p0.h2j();
}
function ProjectTimer_executed$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(11);
}
function ProjectTimer_executed$_get_annotations_$ref_b2cj4q() {
  return (p0) => p0.bz();
}
var ProjectTimer_executedClass;
function ProjectTimer_executed() {
  if (ProjectTimer_executedClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_executed_instance = this;
        var tmp = this;
        tmp.m7u_1 = lazy(ProjectTimer_executed$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n7u_1 = lazy(ProjectTimer_executed$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o7u_1 = lazy(ProjectTimer_executed$annotations$delegate$lambda);
        this.p7u_1 = null;
        this.q7u_1 = 'null';
      }
      i20() {
        var tmp0 = this.m7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_executed$_get_name_$ref_b4m1tb(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.a7u_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      r7u(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.r7u(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_executed$_get_serializer_$ref_5giw6i(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_executed$_get_annotations_$ref_b2cj4q(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_executed', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_executedClass = $;
  }
  return ProjectTimer_executedClass;
}
var ProjectTimer_executed_instance;
function ProjectTimer_executed_getInstance() {
  if (ProjectTimer_executed_instance === VOID)
    new (ProjectTimer_executed())();
  return ProjectTimer_executed_instance;
}
function ProjectTimer_project$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(1);
}
function ProjectTimer_project$_get_name_$ref_2tshql() {
  return (p0) => p0.i20();
}
function ProjectTimer_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_project$_get_serializer_$ref_qouiue() {
  return (p0) => p0.h2j();
}
function ProjectTimer_project$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(1);
}
function ProjectTimer_project$_get_annotations_$ref_tycjxa() {
  return (p0) => p0.bz();
}
var ProjectTimer_projectClass;
function ProjectTimer_project() {
  if (ProjectTimer_projectClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_project_instance = this;
        var tmp = this;
        tmp.s7u_1 = lazy(ProjectTimer_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.t7u_1 = lazy(ProjectTimer_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.u7u_1 = lazy(ProjectTimer_project$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.s7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_project$_get_name_$ref_2tshql(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.q7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      v7u(receiver, value) {
        return receiver.c7u(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.v7u(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.t7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_project$_get_serializer_$ref_qouiue(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.u7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_project$_get_annotations_$ref_tycjxa(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_project', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_projectClass = $;
  }
  return ProjectTimer_projectClass;
}
var ProjectTimer_project_instance;
function ProjectTimer_project_getInstance() {
  if (ProjectTimer_project_instance === VOID)
    new (ProjectTimer_project())();
  return ProjectTimer_project_instance;
}
function ProjectTimer__id$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(0);
}
function ProjectTimer__id$_get_name_$ref_52h5ro() {
  return (p0) => p0.i20();
}
function ProjectTimer__id$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer__id$_get_serializer_$ref_9l7ckl() {
  return (p0) => p0.h2j();
}
function ProjectTimer__id$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(0);
}
function ProjectTimer__id$_get_annotations_$ref_2ytgox() {
  return (p0) => p0.bz();
}
var ProjectTimer__idClass;
function ProjectTimer__id() {
  if (ProjectTimer__idClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer__id_instance = this;
        var tmp = this;
        tmp.w7u_1 = lazy(ProjectTimer__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x7u_1 = lazy(ProjectTimer__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y7u_1 = lazy(ProjectTimer__id$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer__id$_get_name_$ref_52h5ro(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.p7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      v7u(receiver, value) {
        return receiver.c7u(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.v7u(tmp, value instanceof UUID() ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer__id$_get_serializer_$ref_9l7ckl(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer__id$_get_annotations_$ref_2ytgox(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer__id', VOID, VOID, [SerializableProperty()]);
    ProjectTimer__idClass = $;
  }
  return ProjectTimer__idClass;
}
var ProjectTimer__id_instance;
function ProjectTimer__id_getInstance() {
  if (ProjectTimer__id_instance === VOID)
    new (ProjectTimer__id())();
  return ProjectTimer__id_instance;
}
function ProjectTimer_payApp$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(4);
}
function ProjectTimer_payApp$_get_name_$ref_5nlb47() {
  return (p0) => p0.i20();
}
function ProjectTimer_payApp$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_payApp$_get_serializer_$ref_84149s() {
  return (p0) => p0.h2j();
}
function ProjectTimer_payApp$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(4);
}
function ProjectTimer_payApp$_get_annotations_$ref_gjsgys() {
  return (p0) => p0.bz();
}
var ProjectTimer_payAppClass;
function ProjectTimer_payApp() {
  if (ProjectTimer_payAppClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_payApp_instance = this;
        var tmp = this;
        tmp.z7u_1 = lazy(ProjectTimer_payApp$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a7v_1 = lazy(ProjectTimer_payApp$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b7v_1 = lazy(ProjectTimer_payApp$annotations$delegate$lambda);
        this.c7v_1 = null;
        this.d7v_1 = 'null';
      }
      i20() {
        var tmp0 = this.z7u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_payApp$_get_name_$ref_5nlb47(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.t7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      b7u(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.b7u(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_payApp$_get_serializer_$ref_84149s(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_payApp$_get_annotations_$ref_gjsgys(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_payApp', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_payAppClass = $;
  }
  return ProjectTimer_payAppClass;
}
var ProjectTimer_payApp_instance;
function ProjectTimer_payApp_getInstance() {
  if (ProjectTimer_payApp_instance === VOID)
    new (ProjectTimer_payApp())();
  return ProjectTimer_payApp_instance;
}
function ProjectTimer_durationLeft$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(5);
}
function ProjectTimer_durationLeft$_get_name_$ref_5li4o5() {
  return (p0) => p0.i20();
}
function ProjectTimer_durationLeft$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_durationLeft$_get_serializer_$ref_hdf7b6() {
  return (p0) => p0.h2j();
}
function ProjectTimer_durationLeft$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(5);
}
function ProjectTimer_durationLeft$_get_annotations_$ref_dl42o6() {
  return (p0) => p0.bz();
}
var ProjectTimer_durationLeftClass;
function ProjectTimer_durationLeft() {
  if (ProjectTimer_durationLeftClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_durationLeft_instance = this;
        var tmp = this;
        tmp.e7v_1 = lazy(ProjectTimer_durationLeft$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.f7v_1 = lazy(ProjectTimer_durationLeft$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.g7v_1 = lazy(ProjectTimer_durationLeft$annotations$delegate$lambda);
        this.h7v_1 = null;
        this.i7v_1 = 'null';
      }
      i20() {
        var tmp0 = this.e7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_durationLeft$_get_name_$ref_5li4o5(), null);
        return tmp0.f2();
      }
      j7v(receiver) {
        return receiver.u7t_1;
      }
      k2j(receiver) {
        var tmp = this.j7v(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
        return tmp == null ? null : new (Duration())(tmp);
      }
      k7v(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof Duration()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.nj_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.k7v(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.f7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_durationLeft$_get_serializer_$ref_hdf7b6(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.g7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_durationLeft$_get_annotations_$ref_dl42o6(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_durationLeft', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_durationLeftClass = $;
  }
  return ProjectTimer_durationLeftClass;
}
var ProjectTimer_durationLeft_instance;
function ProjectTimer_durationLeft_getInstance() {
  if (ProjectTimer_durationLeft_instance === VOID)
    new (ProjectTimer_durationLeft())();
  return ProjectTimer_durationLeft_instance;
}
function ProjectTimer_executesAt$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(6);
}
function ProjectTimer_executesAt$_get_name_$ref_jzgpnz() {
  return (p0) => p0.i20();
}
function ProjectTimer_executesAt$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_executesAt$_get_serializer_$ref_jkly88() {
  return (p0) => p0.h2j();
}
function ProjectTimer_executesAt$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(6);
}
function ProjectTimer_executesAt$_get_annotations_$ref_meayrg() {
  return (p0) => p0.bz();
}
var ProjectTimer_executesAtClass;
function ProjectTimer_executesAt() {
  if (ProjectTimer_executesAtClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_executesAt_instance = this;
        var tmp = this;
        tmp.l7v_1 = lazy(ProjectTimer_executesAt$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.m7v_1 = lazy(ProjectTimer_executesAt$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.n7v_1 = lazy(ProjectTimer_executesAt$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.l7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_executesAt$_get_name_$ref_jzgpnz(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.v7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      r7u(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.r7u(tmp, (value == null ? true : value instanceof Instant()) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.m7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_executesAt$_get_serializer_$ref_jkly88(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.n7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_executesAt$_get_annotations_$ref_meayrg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_executesAt', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_executesAtClass = $;
  }
  return ProjectTimer_executesAtClass;
}
var ProjectTimer_executesAt_instance;
function ProjectTimer_executesAt_getInstance() {
  if (ProjectTimer_executesAt_instance === VOID)
    new (ProjectTimer_executesAt())();
  return ProjectTimer_executesAt_instance;
}
function ProjectTimer_pausedFromDispute$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(7);
}
function ProjectTimer_pausedFromDispute$_get_name_$ref_sl06ca() {
  return (p0) => p0.i20();
}
function ProjectTimer_pausedFromDispute$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_pausedFromDispute$_get_serializer_$ref_z2yu8d() {
  return (p0) => p0.h2j();
}
function ProjectTimer_pausedFromDispute$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(7);
}
function ProjectTimer_pausedFromDispute$_get_annotations_$ref_wu3rw1() {
  return (p0) => p0.bz();
}
var ProjectTimer_pausedFromDisputeClass;
function ProjectTimer_pausedFromDispute() {
  if (ProjectTimer_pausedFromDisputeClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_pausedFromDispute_instance = this;
        var tmp = this;
        tmp.o7v_1 = lazy(ProjectTimer_pausedFromDispute$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.p7v_1 = lazy(ProjectTimer_pausedFromDispute$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.q7v_1 = lazy(ProjectTimer_pausedFromDispute$annotations$delegate$lambda);
        this.r7v_1 = false;
        this.s7v_1 = 'false';
      }
      i20() {
        var tmp0 = this.o7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_pausedFromDispute$_get_name_$ref_sl06ca(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.w7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      t7v(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.t7v(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.p7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_pausedFromDispute$_get_serializer_$ref_z2yu8d(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.q7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_pausedFromDispute$_get_annotations_$ref_wu3rw1(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_pausedFromDispute', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_pausedFromDisputeClass = $;
  }
  return ProjectTimer_pausedFromDisputeClass;
}
var ProjectTimer_pausedFromDispute_instance;
function ProjectTimer_pausedFromDispute_getInstance() {
  if (ProjectTimer_pausedFromDispute_instance === VOID)
    new (ProjectTimer_pausedFromDispute())();
  return ProjectTimer_pausedFromDispute_instance;
}
function ProjectTimer_businessDaysOnly$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(9);
}
function ProjectTimer_businessDaysOnly$_get_name_$ref_q0a7kt() {
  return (p0) => p0.i20();
}
function ProjectTimer_businessDaysOnly$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[9];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_businessDaysOnly$_get_serializer_$ref_dkxrm2() {
  return (p0) => p0.h2j();
}
function ProjectTimer_businessDaysOnly$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(9);
}
function ProjectTimer_businessDaysOnly$_get_annotations_$ref_ay3inm() {
  return (p0) => p0.bz();
}
var ProjectTimer_businessDaysOnlyClass;
function ProjectTimer_businessDaysOnly() {
  if (ProjectTimer_businessDaysOnlyClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_businessDaysOnly_instance = this;
        var tmp = this;
        tmp.u7v_1 = lazy(ProjectTimer_businessDaysOnly$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.v7v_1 = lazy(ProjectTimer_businessDaysOnly$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.w7v_1 = lazy(ProjectTimer_businessDaysOnly$annotations$delegate$lambda);
        this.x7v_1 = false;
        this.y7v_1 = 'false';
      }
      i20() {
        var tmp0 = this.u7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_businessDaysOnly$_get_name_$ref_q0a7kt(), null);
        return tmp0.f2();
      }
      o7t(receiver) {
        return receiver.y7t_1;
      }
      k2j(receiver) {
        return this.o7t(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
      }
      t7v(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        return this.t7v(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.v7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_businessDaysOnly$_get_serializer_$ref_dkxrm2(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.w7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_businessDaysOnly$_get_annotations_$ref_ay3inm(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_businessDaysOnly', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_businessDaysOnlyClass = $;
  }
  return ProjectTimer_businessDaysOnlyClass;
}
var ProjectTimer_businessDaysOnly_instance;
function ProjectTimer_businessDaysOnly_getInstance() {
  if (ProjectTimer_businessDaysOnly_instance === VOID)
    new (ProjectTimer_businessDaysOnly())();
  return ProjectTimer_businessDaysOnly_instance;
}
function ProjectTimer_minimumTimeWhenResumed$name$delegate$lambda() {
  return Companion_getInstance().k2a().az().v11(10);
}
function ProjectTimer_minimumTimeWhenResumed$_get_name_$ref_ubldoe() {
  return (p0) => p0.i20();
}
function ProjectTimer_minimumTimeWhenResumed$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[10];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function ProjectTimer_minimumTimeWhenResumed$_get_serializer_$ref_fhw8gn() {
  return (p0) => p0.h2j();
}
function ProjectTimer_minimumTimeWhenResumed$annotations$delegate$lambda() {
  return Companion_getInstance().k2a().az().x11(10);
}
function ProjectTimer_minimumTimeWhenResumed$_get_annotations_$ref_wwq60j() {
  return (p0) => p0.bz();
}
var ProjectTimer_minimumTimeWhenResumedClass;
function ProjectTimer_minimumTimeWhenResumed() {
  if (ProjectTimer_minimumTimeWhenResumedClass === VOID) {
    class $ {
      constructor() {
        ProjectTimer_minimumTimeWhenResumed_instance = this;
        var tmp = this;
        tmp.z7v_1 = lazy(ProjectTimer_minimumTimeWhenResumed$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a7w_1 = lazy(ProjectTimer_minimumTimeWhenResumed$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b7w_1 = lazy(ProjectTimer_minimumTimeWhenResumed$annotations$delegate$lambda);
        this.c7w_1 = null;
        this.d7w_1 = 'null';
      }
      i20() {
        var tmp0 = this.z7v_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, ProjectTimer_minimumTimeWhenResumed$_get_name_$ref_ubldoe(), null);
        return tmp0.f2();
      }
      j7v(receiver) {
        return receiver.z7t_1;
      }
      k2j(receiver) {
        var tmp = this.j7v(receiver instanceof ProjectTimer() ? receiver : THROW_CCE());
        return tmp == null ? null : new (Duration())(tmp);
      }
      k7v(receiver, value) {
        return receiver.c7u(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof ProjectTimer() ? receiver : THROW_CCE();
        var tmp_0;
        if (value == null ? true : value instanceof Duration()) {
          var tmp_1 = value;
          tmp_0 = tmp_1 == null ? null : tmp_1.nj_1;
        } else {
          tmp_0 = THROW_CCE();
        }
        return this.k7v(tmp, tmp_0);
      }
      h2j() {
        var tmp0 = this.a7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, ProjectTimer_minimumTimeWhenResumed$_get_serializer_$ref_fhw8gn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b7w_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, ProjectTimer_minimumTimeWhenResumed$_get_annotations_$ref_wwq60j(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'ProjectTimer_minimumTimeWhenResumed', VOID, VOID, [SerializableProperty()]);
    ProjectTimer_minimumTimeWhenResumedClass = $;
  }
  return ProjectTimer_minimumTimeWhenResumedClass;
}
var ProjectTimer_minimumTimeWhenResumed_instance;
function ProjectTimer_minimumTimeWhenResumed_getInstance() {
  if (ProjectTimer_minimumTimeWhenResumed_instance === VOID)
    new (ProjectTimer_minimumTimeWhenResumed())();
  return ProjectTimer_minimumTimeWhenResumed_instance;
}
//region block: exports
export {
  get_action as get_action1la6do8qxhniz,
  get_executed as get_executedyhzhm61p8o8r,
  get_executesAt as get_executesAt1z26sgmqnektw,
  get_incident as get_incident1vs82es68w39g,
  get_lineItem as get_lineItem1imixnvdujbj8,
  prepareProjectTimerFields as prepareProjectTimerFields3bq34fr6eveey,
  get_project as get_projectuqhdbpbkwkr4,
};
//endregion

//# sourceMappingURL=ProjectTimerFields.mjs.map
